import { setUrlFromState } from "../helpers/setUrlFromState";
import { Data, DataCheckboxesOptions } from "../types/Data";
import { State } from "../types/State";
import { GroupLabel } from "./GroupLabel";
import { Store } from "./Store";

export class CheckboxesInput {
  store: Store;
  data: Data;
  name: keyof State;
  label: GroupLabel;
  checked: string[] = [];

  constructor({
    store,
    data,
    name,
    label,
  }: {
    store: Store;
    data: Data;
    name: keyof State;
    label: GroupLabel;
  }) {
    this.store = store;
    this.data = data;
    this.name = name;
    this.label = label;
    this.checked = (this.store.getState()[this.name] ?? []) as string[];
    this.#initChecked();
    this.#registerOnChange();
    this.#renderLabel();
  }

  #initChecked() {
    this.checked.map((value) => {
      (
        ((this.data[this.name] as DataCheckboxesOptions)[value]?.element
          .children[0] as HTMLInputElement) || {}
      ).checked = true;
    });
  }

  #registerOnChange() {
    Object.entries(this.data[this.name] as DataCheckboxesOptions).forEach(
      ([value, { element }], index) => {
        element.addEventListener("click", (event) => {
          if (event.target !== element.children[0]) return;
          const isChecked = this.checked.includes(value);
          if (isChecked) this.checked = this.checked.filter((v) => v !== value);
          else this.checked.push(value);
          (
            (this.data[this.name] as DataCheckboxesOptions)[value].element
              .children[0] as HTMLInputElement
          ).checked = !isChecked;
          this.store.updateState(this.name, this.checked);
          this.#renderLabel();
          setUrlFromState(this.store.getState());
        });
      }
    );
  }

  #renderLabel() {
    this.label.refresh({
      state: this.store.getState(),
      data: this.data,
    });
  }
}
